import * as React from "react";
const SvgNotification = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="m23.51 16.857-1.587-2.639c-.35-.575-.66-1.684-.66-2.358V9.235c0-5.094-4.14-9.235-9.22-9.235-5.096.014-9.236 4.14-9.236 9.235v2.611c0 .674-.309 1.783-.646 2.358L.575 16.843c-.603 1.024-.744 2.19-.365 3.2.38 1.024 1.235 1.839 2.358 2.204 1.516.505 3.046.87 4.604 1.136.154.028.309.043.463.07.197.029.407.057.618.085.365.056.73.098 1.108.126a28.3 28.3 0 0 0 5.32 0c.323-.028.646-.056.954-.098.253-.028.506-.056.758-.098.155-.014.31-.043.463-.07a29.6 29.6 0 0 0 4.646-1.151 3.72 3.72 0 0 0 2.302-2.218 3.66 3.66 0 0 0-.295-3.172M15.987 25.207A4.23 4.23 0 0 1 12.015 28a4.16 4.16 0 0 1-2.976-1.25 3.9 3.9 0 0 1-.982-1.557c.182.028.365.042.561.07.323.042.66.084.997.112.8.07 1.614.113 2.428.113.8 0 1.6-.043 2.386-.113.295-.028.59-.042.87-.084.225-.028.45-.056.688-.084"
    />
  </svg>
);
export default SvgNotification;
